import { useSuspenseQuery } from "@tanstack/react-query";
import API from "Api";
import React, { useEffect, useState } from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Rate } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LessonType } from "App.types";
import { closeMiniApp, isTMA } from "@telegram-apps/sdk-react";

type Props = {
  lesson?: LessonType;
  onRepeat: Function;
  onContinue?: Function;
  hideModal?: boolean;
};

const useProgress = ({ lesson, onRepeat, hideModal = false }: Props) => {
  const { data: progress, refetch } = useSuspenseQuery({
    queryKey: ["progress", lesson?.id],
    // enabled: !!lesson,
    queryFn: () => (lesson ? API.progress.getForLesson(lesson.id) : undefined),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    gcTime: 0,
  });

  const [showModal, setShowModal] = useState(!hideModal);

  useEffect(() => {
    if (progress && !progress?.some((pr) => pr.type)) {
      setShowModal(false);
    }
    // setShowModal((prev) => (prev ? !!progress?.length : prev));
  }, [progress]);

  const { course } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    if (!showModal) return;

    const hasProgress = progress?.some((pr) => pr.type);
    const completed = progress?.find((pr) => pr.status === "completed");

    if (hasProgress && !completed) {
      modal.confirm({
        title: "Задание осталось незавершенным",
        icon: <ExclamationCircleOutlined />,
        content: "",
        okText: "Продолжить",
        cancelText: "Начать с начала",
        onOk: () => {
          setShowModal(false);
          // onContinue?.(lessonProgress);
          // setPercent(lessonProgress.percent || 0);
          // setActiveTaskIdx(lesson?.tasks[0] === TaskType.Mixed ? 0 : tasks.findIndex((task) => task === progress?.type));
          //onNext(findIndex(sentences, (s) => s.id === progress.sentence.id));
        },
        onCancel: () => {
          setShowModal(false);
          onRepeat();
        },
      });
    }

    if (completed) {
      modal.confirm({
        title: "Задание уже пройдено",
        icon: <ExclamationCircleOutlined />,
        content: (
          <Flex vertical>
            <Rate allowHalf disabled defaultValue={completed.stars} />
            {isTMA() && (
              <Button block variant={"outlined"} color={"primary"} onClick={() => closeMiniApp()}>
                В телегу
              </Button>
            )}
          </Flex>
        ),
        cancelText: "Пройти заново",
        okText: "Вернуться в задания",
        onOk: () => (state ? navigate(-1) : navigate(`/course/${course}`, { state: { lessonId: lesson?.id } })),
        onCancel: () => {
          setShowModal(false);

          onRepeat();
        },
      });
    }
  }, [state, course, modal, navigate, onRepeat, progress, showModal, lesson?.id]);

  return { progress, contextHolder, refetch, showProgressModal: showModal };
};

export default useProgress;
